export default "__VITE_ASSET__DZirDO6i__"